"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("../Dataset");
/**
 * NFT Collection Dataset
 */
class CollectionDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Create NFT Collection.
         *
         * @param req Use {@link Build5Request} with data based on {@link CreateCollectionRequest}
         * @returns
         */
        this.create = (req) => this.sendRequest(interfaces_1.WEN_FUNC.createCollection)(req);
        /**
         * Update NFT Collection.
         *
         * @param req Use {@link Build5Request} with data based on {@link UpdateCollectionRequest}
         * @returns
         */
        this.update = (req) => this.sendRequest(interfaces_1.WEN_FUNC.updateCollection)(req);
        /**
         * Update minted NFT Collection. Only certain fields are updated (typically those that are not immutable and stored on DLT)
         *
         * @param req Use {@link Build5Request} with data based on {@link UpdateCollectionRequest}
         * @returns
         */
        this.updateMinted = (req) => this.sendRequest(interfaces_1.WEN_FUNC.updateCollection)(req);
        /**
         * Reject collection and hide it.
         *
         * @param req Use {@link Build5Request} with data based on {@link RejectCollectionRequest}
         * @returns
         */
        this.reject = (req) => this.sendRequest(interfaces_1.WEN_FUNC.rejectCollection)(req);
        /**
         * Mint collection on defined network.
         *
         * @param req Use {@link Build5Request} with data based on {@link CollectionMintRequest}
         * @returns
         */
        this.mint = (req) => this.sendRequest(interfaces_1.WEN_FUNC.mintCollection)(req);
        /**
         * Give collection a vote up or down.
         *
         * @param req Use {@link Build5Request} with data based on {@link VoteRequest}
         * @returns
         */
        this.vote = (req) => this.sendRequest(interfaces_1.WEN_FUNC.voteController)(req);
        /**
         * Rank collection. This typically is managed by Rank Moderators.
         *
         * @param req Use {@link Build5Request} with data based on {@link RankRequest}
         * @returns
         */
        this.rank = (req) => this.sendRequest(interfaces_1.WEN_FUNC.rankController)(req);
        /**
         * Get all pending collections per space. Real time stream.
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getAllPendingLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'approved', 'rejected'],
                fieldValue: [space, false, false],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * Get all available collections per space. Real time stream.
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getAllAvailableLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'approved'],
                fieldValue: [space, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * Get all rejected collections per space. Real time stream.
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getAllRejectedLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'rejected'],
                fieldValue: [space, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.CollectionDataset = CollectionDataset;
